import { useState } from 'react';

import { ActionCardTitleRow } from './ActionCardTitleRow';
import { ActionCardFooter } from './ActionCardFooter';
import { WorkItemsModal } from '../WorkItemsModal';
import { Box, Paper, Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { QeScoreRecommendedAction } from '../../../../interfaces';
import { useStyles } from '../../../../styles';
import { TITLE_NEXT_ACTIONS_MAP } from '../../../../constants';
import { useParams } from 'react-router-dom';

export function QEScoreRecommendedActionCard({
  actionItem,
}: {
  actionItem: QeScoreRecommendedAction;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    title,
    workItemsCount,
    actionType,
    priority,
    actionText,
    links = [],
  } = actionItem;
  const classes = useStyles();

  const { projectId } = useParams();
  const actionConfig =
    TITLE_NEXT_ACTIONS_MAP[title as keyof typeof TITLE_NEXT_ACTIONS_MAP];
  const nextAction = actionConfig?.nextAction;
  const actionUrl = actionConfig?.getUrl(projectId) ?? '';

  return (
    <>
      <Paper variant="outlined" className={classes.indexAnalysisSummaryPaper}>
        <div className="flex flex-col gap-2">
          <ActionCardTitleRow
            title={title}
            itemsCount={workItemsCount}
            badgeLabel={actionType}
            priority={priority}
          />
          <ActionCardFooter
            nextActionUrl={actionUrl}
            hasWorkItems={links?.length > 0}
            actionText={actionText}
            onViewDetails={() => setIsModalOpen(true)}
          />
          {links?.length === 0 && nextAction && (
            <Box className={classes.nextActionAlertBox}>
              <InfoOutlinedIcon className={classes.nextActionAlertIcon} />
              <Typography
                component="span"
                variant="body2"
                className={classes.nextActionAlertText}
              >
                {nextAction}
              </Typography>
            </Box>
          )}
        </div>
      </Paper>

      <WorkItemsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={title}
        itemsCount={workItemsCount}
        badgeLabel={actionType}
        description={actionText}
        priority={priority}
        links={links}
      />
    </>
  );
}
